export function extractPhotoCollection(value: unknown): unknown[] {
  if (Array.isArray(value)) {
    return value;
  }

  if (!value || typeof value !== "object") {
    return [];
  }

  const record = value as Record<string, unknown>;

  if (Array.isArray(record.data)) {
    return record.data;
  }

  return Object.values(record).filter(
    (entry) => entry != null && typeof entry === "object"
  );
}
